// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NicheTab {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 60px;
}
.NicheTab .leftSection {
  display: flex;
  flex-direction: row;
}
.NicheTab .NicheDescriptionContent {
  margin-bottom: 40px;
}
.NicheTab .NicheTable {
  margin-top: 24px;
}
.NicheTab .NicheTab-tableTitleRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.NicheTab .HappeningNowAlert {
  margin-bottom: 40px;
}
.NicheTab .IconZaiAnimation {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.NicheTab .NicheTab-skeletonWrapper {
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  margin-top: 32px;
}
.NicheTab .NicheTab-skeletonRow {
  display: grid;
  grid-template-columns: 40px 320px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
}
.NicheTab .NicheTab-skeletonNameCell {
  margin-left: 44px;
}
.NicheTab .NicheTab-valueCell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.NicheTab .NicheTab-loadingTitle {
  margin-left: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  gap: 8px;
  color: var(--color_neutral_800);
}
.NicheTab .NicheTab-loadingTitle .NicheTab-loadingCircle {
  width: 24px;
  height: 24px;
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/niche-tab/niche-tab.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AALJ;AAQE;EACE,aAAA;EACA,6FAAA;AANJ;AASE;EACE,iBAAA;AAPJ;AAUE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AARJ;AAWE;EACE;IACE,uBAAA;EATJ;EAYE;IACE,yBAAA;EAVJ;AACF;AAaE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,+BAAA;AAXJ;AAaI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,iCAAA;AAXN","sourcesContent":[".NicheTab {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  padding-bottom: 60px;\n\n  .leftSection {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .NicheDescriptionContent {\n    margin-bottom: 40px;\n  }\n\n  .NicheTable {\n    margin-top: 24px;\n  }\n\n  .NicheTab-tableTitleRow {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .HappeningNowAlert {\n    margin-bottom: 40px;\n  }\n\n  .IconZaiAnimation {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .NicheTab-skeletonWrapper {\n    display: flex;\n    flex-direction: column;\n    row-gap: 32px;\n    margin-top: 32px;\n  }\n\n  .NicheTab-skeletonRow {\n    display: grid;\n    grid-template-columns: 40px 320px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);\n  }\n\n  .NicheTab-skeletonNameCell {\n    margin-left: 44px;\n  }\n\n  .NicheTab-valueCell {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  .NicheTab-loadingTitle {\n    margin-left: 16px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    font-size: 16px;\n    gap: 8px;\n    color: var(--color_neutral_800);\n\n    .NicheTab-loadingCircle {\n      width: 24px;\n      height: 24px;\n      animation-name: spin;\n      animation-duration: 1000ms;\n      animation-iteration-count: infinite;\n      animation-timing-function: linear;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
